import React, { useState } from "react";
import { MessageCircle, ArrowRight, Trash2 } from "lucide-react";
import { Button } from "./ui/button";
import { api } from "../api";
import { InquiryReplies } from "./InquiryReplies";
import { useApp } from "../context/AppContext";

export const INQUIRY_STATUSES = ["New", "In progress", "Closed"];

export const InquiryCard = ({ inquiry, onUpdated, onError, onDeleted }) => {
  const { user } = useApp();
  const [busy, setBusy] = useState(false);
  const id = inquiry.id;
  const update = async (status) => {
    setBusy(true);
    try { onUpdated(await api.updateInquiry(id, status)); }
    catch (error) { onError(error); }
    finally { setBusy(false); }
  };
  const del = async () => {
    if (!window.confirm("Delete this inquiry permanently? This cannot be undone.")) return;
    setBusy(true);
    try { await api.deleteInquiry(id); onDeleted && onDeleted(id); }
    catch (error) { onError(error); }
    finally { setBusy(false); }
  };
  const customerUrl = `https://wa.me/${inquiry.phone.replace(/\D/g, "")}?text=${encodeURIComponent(`Hello ${inquiry.name}, regarding your SmartLogistics inquiry ${id} (${inquiry.senderCountry} → ${inquiry.receiverCountry}):`)}`;
  return <article data-testid={`inquiry-card-${id}`} className="border border-black/10 rounded-lg bg-white p-5 sm:p-6 min-w-0">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0">
        <p data-testid={`inquiry-route-${id}`} className="font-display font-semibold flex flex-wrap items-center gap-2">{inquiry.senderCountry}<ArrowRight className="w-4 h-4 text-orange-600 shrink-0" />{inquiry.receiverCountry}</p>
        <p data-testid={`inquiry-reference-${id}`} className="text-xs text-neutral-500 mt-2 break-all">{id} · {new Date(inquiry.createdAt).toLocaleString()}</p>
      </div>
      <select data-testid={`inquiry-status-${id}`} aria-label="Inquiry status" value={inquiry.status} onChange={(e) => update(e.target.value)} disabled={busy} className="rounded-lg border border-black/10 bg-white px-3 h-10 text-sm max-w-full">
        {INQUIRY_STATUSES.map((status) => <option data-testid={`inquiry-status-${id}-${status.toLowerCase().replace(/ /g, "-")}`} key={status}>{status}</option>)}
      </select>
      {user?.role === "admin" && (
        <Button onClick={del} disabled={busy} variant="outline" size="icon" data-testid={`inquiry-delete-${id}`} className="border-red-200 text-red-600 hover:bg-red-50 h-10 w-10 shrink-0"><Trash2 className="w-4 h-4" /></Button>
      )}
    </div>
    <div className="mt-5 grid sm:grid-cols-2 gap-4 text-sm">
      <div><p data-testid={`inquiry-name-${id}`} className="font-semibold break-words">{inquiry.name}</p><p data-testid={`inquiry-phone-${id}`} className="text-neutral-600 mt-1 break-words">{inquiry.phone}</p></div>
      <div className="text-neutral-600">
        {inquiry.contents && <p data-testid={`inquiry-contents-${id}`} className="break-words">Contents: {inquiry.contents}</p>}
        {inquiry.weight != null && <p data-testid={`inquiry-weight-${id}`}>Estimated weight: {inquiry.weight} kg</p>}
      </div>
    </div>
    {inquiry.message && <p data-testid={`inquiry-message-${id}`} className="mt-4 whitespace-pre-wrap break-words text-sm text-neutral-700 border-l-2 border-orange-400 pl-3">{inquiry.message}</p>}
    <Button asChild variant="outline" className="mt-5 gap-2 max-w-full whitespace-normal h-auto min-h-10 py-2"><a data-testid={`inquiry-reply-${id}`} href={customerUrl} target="_blank" rel="noopener noreferrer"><MessageCircle className="w-4 h-4 text-orange-600 shrink-0" />WhatsApp customer</a></Button>
    <InquiryReplies inquiry={inquiry} onUpdated={onUpdated} onError={onError} />
  </article>;
};